import React, { useState } from "react";
import { useStaticQuery, graphql } from "gatsby";
import AniLink from "gatsby-plugin-transition-link/AniLink";

import ModalContact from "../Modal/ModalContact";

const Footer = () => {
  const getYear = () => {
    return new Date().getFullYear();
  };

  const [cityDropdownOpen, setCityDropdownOpen] = useState(false);
  const [serviceDropdownOpen, setServiceDropdownOpen] = useState(false);

  const citiesClickHandler = () => {
    setCityDropdownOpen(!cityDropdownOpen);
    setServiceDropdownOpen(false);
  };

  const servicesClickHandler = () => {
    setServiceDropdownOpen(!serviceDropdownOpen);
    setCityDropdownOpen(false);
  };

  const badge = `<script type='text/javascript' src='https://www.rapidscansecure.com/siteseal/siteseal.js?code=155,8F17524F2CE744D74DCF189E0B4CEC80B55D1635'></script>`;

  const data = useStaticQuery(graphql`
    {
      logo: file(relativePath: { eq: "global/Logo-grayscale.png" }) {
        publicURL
      }
      nestLogo: file(relativePath: { eq: "global/Nest Logo.svg" }) {
        publicURL
      }
    }
  `);

  const navigation = {
    links: [
      { name: "Services", href: "/services/" },
      { name: "About", href: "/about/" },
      { name: "Reviews", href: "/reviews/" },
      { name: "Careers", href: "/careers/" },
      { name: "Sustainability", href: "/sustainability/" },
      { name: "Blog", href: "/blog/" },
    ],
    cities: [
      { name: "Aspen", href: "/aspen-hospitality-staffing/" },
      { name: "Dallas", href: "/dallas-hospitality-staffing/" },
      { name: "Denver", href: "/denver-hospitality-staffing/" },
      { name: "Los Angeles", href: "/los-angeles-hospitality-staffing/" },
      { name: "Miami", href: "/miami-hospitality-staffing/" },
      { name: "Minneapolis", href: "/minneapolis-hospitality-staffing/" },
      { name: "Nashville", href: "/nashville-hospitality-staffing/" },
      // { name: "Oklahoma City", href: "/oklahoma-city-hospitality-staffing/" },
      { name: "Orlando", href: "/orlando-hospitality-staffing/" },
      { name: "Palm Springs", href: "/palm-springs-hospitality-staffing/" },
      { name: "Park City", href: "/park-city-hospitality-staffing/" },
      { name: "Phoenix", href: "/phoenix-hospitality-staffing/" },
      { name: "Salt Lake City", href: "/salt-lake-city-hospitality-staffing/" },
      { name: "San Diego", href: "/san-diego-hospitality-staffing/" },
      { name: "Savannah", href: "/savannah-hospitality-staffing/" },
      { name: "Tampa", href: "/tampa-hospitality-staffing/" },
      { name: "Tucson", href: "/tucson-hospitality-staffing/" },
    ],
    services: [
      { name: "Resort Cleaning", href: "/resort-cleaning/" },
      { name: "Restaurant Cleaning", href: "/restaurant-cleaning/" },
      {
        name: "Commercial Kitchen Cleaning",
        href: "/commercial-kitchen-cleaning/",
      },
      { name: "Spa Cleaning", href: "/spa-cleaning/" },
      { name: "Commercial Cleaning", href: "/commercial-cleaning/" },
      { name: "Hard Surface Floor Care", href: "/hard-surface-floor-care/" },
      { name: "Hotel Disinfecting", href: "/hotel-disinfecting/" },
      { name: "Hotel Housekeeping", href: "/hotel-housekeeping/" },
      { name: "Hotel & Hospitality Staffing", href: "/hospitality-staffing/" },
      { name: "Restoration Services", href: "/hotel-restoration/" },
    ],
    social: [
      // {
      //   name: "Facebook",
      //   href: "https://www.facebook.com/hotelcleaningservices",
      //   icon: "fab fa-facebook-f",
      // },
      // {
      //   name: "Linkedin",
      //   href: "https://www.linkedin.com/company/hotel-services/about/",
      //   icon: "fab fa-linkedin-in",
      // },
      // {
      //   name: "Yelp",
      //   href: "#",
      //   icon: "fab fa-yelp",
      // },
    ],
  };

  return (
    <>
      <footer className="border-t border-primary-500 bg-gradient-to-b from-gray-900 via-black to-gray-900 pt-8 md:pt-10 pb-10 md:pb-6">
        <div className="container">
          <div className="flex flex-col md:flex-row md:justify-between space-y-8 md:space-y-0 md:space-x-6 md:mb-10">
            <div>
              <AniLink fade to="/">
                <img
                  src={data.logo.publicURL}
                  alt="Hotel Cleaning Services Logo"
                  width="97"
                  // className="mx-auto md:mx-0"
                />
              </AniLink>
            </div>
            <div dangerouslySetInnerHTML={{ __html: badge }} />

            <div>
              <ul className="grid md:flex flex-col md:flex-row grid-cols-2 gap-x-10 md:gap-x-0 gap-y-2 md:gap-y-0 md:mt-8 mb-14 md:mb-12 md:space-x-6 max-w-xs md:max-w-full">
                {navigation.links.map((item) => (
                  <li key={item.name}>
                    <AniLink
                      fade
                      to={item.href}
                      className="text-gray-50/50 hover:text-primary-400 uppercase no-underline font-bold"
                    >
                      {item.name}
                    </AniLink>
                  </li>
                ))}
                <li>
                  <button
                    data-modal-open="modal-contact"
                    className="text-gray-50/50 hover:text-primary-400 uppercase no-underline font-bold"
                  >
                    Contact
                  </button>
                </li>
              </ul>

              {/* <div className="flex flex-row md:justify-end my-5 md:my-0 space-x-4">
                {navigation.social.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    target="_blank"
                    rel="noreferrer"
                    className="text-primary-500 hover:text-white bg-transparent hover:bg-primary-500 rounded-full w-8 h-8 flex items-center justify-center border border-primary-500 no-underline"
                  >
                    <span className="sr-only">{item.name}</span>
                    <i
                      className={`text-sm ${item.icon}`}
                      aria-hidden="true"
                    ></i>
                  </a>
                ))}
              </div> */}
            </div>
          </div>

          <div className="flex flex-wrap md:flex-nowrap flex-col md:flex-row justify-items-center md:justify-between md:items-center md:pt-4">
            <div className="md:flex md:items-center order-2 md:order-1">
              <ul className="flex items-center flex-row flex-wrap md:space-x-4 justify-center md:justify-start text-center md:text-left">
                <li className="text-sm text-gray-50 w-full md:w-auto">
                  © {getYear()} Hotel Cleaning Services
                </li>
                <div className="flex space-x-4 justify-center md:justify-start w-full md:w-auto">
                  {/* <li className="text-sm">
                    <a
                      href="/terms-conditions/"
                      className="font-normal text-gray-50 hover:text-gray-50 md: hover:text-opacity-100 no-underline"
                    >
                      Terms & Conditions
                    </a>
                  </li> */}
                  <li className="text-sm">
                    <AniLink
                      fade
                      to="/privacy-policy/"
                      className="font-normal text-gray-50 hover:text-gray-50 md: hover:text-opacity-100 no-underline"
                    >
                      Privacy Policy
                    </AniLink>
                  </li>
                  <li className="text-sm text-gray-50 md:">
                    <div className="flex items-center justify-center">
                      Powered by
                      <a
                        className="group ml-1 no-underline"
                        href="https://www.wisedigitalpartners.com/affordable-web-design/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <svg
                          width="74"
                          height="20"
                          viewBox="0 0 74 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M11.2801 6.37958L10.4718 7.95657L10.4724 7.95438L9.63906 6.37738C9.61378 6.32744 9.54825 6.26513 9.45808 6.37809L9.45907 6.37683C9.239 6.62916 8.9608 6.82561 8.64788 6.94966C8.33496 7.07371 7.99646 7.12173 7.66084 7.08968C7.32522 7.05764 7.00229 6.94647 6.71922 6.76552C6.43614 6.58457 6.20119 6.33913 6.03413 6.04984C5.86706 5.76055 5.77276 5.43587 5.75916 5.10309C5.74555 4.77032 5.81304 4.43918 5.95595 4.13753C6.09886 3.83588 6.31301 3.57253 6.58039 3.36962C6.84778 3.16672 7.16057 3.03019 7.49249 2.97153L7.41971 2.98085C6.85918 2.5578 6.43364 2.52487 6.31587 2.57975C4.69316 3.29746 4.34484 5.42646 6.2531 7.51815C6.2599 7.52783 6.26337 7.53942 6.26299 7.5512C6.26261 7.56298 6.2584 7.57432 6.25099 7.58356C6.24357 7.59279 6.23334 7.59942 6.22182 7.60246C6.21029 7.60551 6.19808 7.6048 6.18699 7.60046C3.55936 6.24786 3.99485 3.51636 4.20461 2.20071V2.2007L4.20461 2.2007C4.2537 1.89277 4.29043 1.6624 4.27263 1.54542C4.20617 1.1049 3.95031 0.695502 3.77351 0.412626C3.73009 0.343153 3.69144 0.281312 3.66154 0.228516C3.64772 0.204444 3.64075 0.177121 3.6414 0.149453C3.64204 0.121785 3.65027 0.0948068 3.6652 0.0713889C3.68013 0.0479709 3.70121 0.0289891 3.7262 0.0164626C3.75118 0.00393621 3.77914 -0.0016662 3.80709 0.000251427C4.04996 0.0154711 4.46822 0.273821 5.0318 0.621931C6.25626 1.37825 8.16667 2.55826 10.4546 2.58907C12.7431 2.55825 14.6544 1.37765 15.8788 0.621357C16.4419 0.273537 16.8597 0.0154628 17.1021 0.000251427C17.1307 -0.00202969 17.1594 0.00359461 17.185 0.0164965C17.2106 0.0293984 17.232 0.0490701 17.247 0.0733158C17.2619 0.0975614 17.2697 0.125427 17.2695 0.153801C17.2693 0.182176 17.2612 0.209943 17.246 0.234003C17.217 0.28484 17.1797 0.34444 17.1378 0.411443L17.1376 0.411776L17.1375 0.411801C16.9609 0.694091 16.7022 1.10764 16.6349 1.55091C16.6172 1.66703 16.6538 1.89623 16.7027 2.20285L16.7027 2.20289C16.9123 3.5161 17.3485 6.24945 14.7211 7.60266C14.71 7.607 14.6978 7.6077 14.6862 7.60466C14.6747 7.60161 14.6645 7.59499 14.6571 7.58575C14.6496 7.57652 14.6454 7.56517 14.6451 7.55339C14.6447 7.54162 14.6481 7.53003 14.655 7.52035C16.5632 5.42921 16.2149 3.3002 14.5922 2.58194C14.4744 2.52981 14.0489 2.55999 13.4883 2.98305L13.4594 2.97921C13.7893 3.04258 14.0989 3.18296 14.3626 3.38865C14.6263 3.59433 14.8363 3.85934 14.9751 4.16154C15.1139 4.46374 15.1776 4.79437 15.1607 5.12581C15.1437 5.45724 15.0468 5.77988 14.8779 6.06676C14.709 6.35364 14.4731 6.59645 14.1898 6.77491C13.9065 6.95336 13.5841 7.06229 13.2496 7.09258C12.915 7.12288 12.5779 7.07366 12.2665 6.94906C11.9551 6.82445 11.6784 6.62806 11.4595 6.37628L11.4668 6.38397C11.3751 6.26599 11.3051 6.33074 11.2801 6.37958ZM8.58742 3.91774C8.31175 3.76464 7.99486 3.69958 7.68026 3.73149C7.32984 3.76704 7.00255 3.92081 6.75352 4.16688C6.50449 4.41296 6.34894 4.7363 6.31309 5.08242C6.28091 5.39318 6.34691 5.70615 6.50203 5.97837C6.65714 6.2506 6.89378 6.46871 7.17943 6.60277C7.46508 6.73684 7.78575 6.78027 8.09739 6.72711C8.40904 6.67394 8.69638 6.5268 8.91997 6.30587C9.14355 6.08494 9.29241 5.80106 9.3461 5.49322C9.3998 5.18538 9.3557 4.86867 9.21986 4.58658C9.08401 4.30449 8.86309 4.07085 8.58742 3.91774ZM14.3677 5.9761C14.5224 5.70356 14.5878 5.39041 14.555 5.07968C14.5183 4.73383 14.3623 4.41099 14.113 4.16546C13.8637 3.91992 13.5364 3.76667 13.1861 3.73149C12.8714 3.69998 12.5546 3.76546 12.2791 3.91896C12.0036 4.07246 11.783 4.30645 11.6475 4.58877C11.5121 4.8711 11.4685 5.18792 11.5227 5.49572C11.5768 5.80352 11.7262 6.08721 11.9502 6.30781C12.1741 6.5284 12.4618 6.6751 12.7735 6.72774C13.0853 6.78039 13.406 6.73639 13.6914 6.60181C13.9769 6.46722 14.2131 6.24865 14.3677 5.9761ZM6.28695 19.1066C6.92701 19.3872 7.59379 19.6041 8.27742 19.7541C8.61926 18.522 9.08063 17.3254 9.65514 16.1809C10.7776 13.9541 12.3082 11.952 14.1694 10.2762H11.2217C9.66358 11.9792 8.3828 13.911 7.42523 16.0025L7.38857 16.0854C6.94763 17.0647 6.57945 18.0745 6.28695 19.1066ZM6.34917 14.7114C6.74391 13.9154 7.18365 13.142 7.66633 12.3948H7.66189C6.94299 11.872 6.42261 11.1259 6.18418 10.2762H3.41818C3.56308 11.1776 3.89907 12.0386 4.40416 12.803C4.90924 13.5673 5.57204 14.2176 6.34917 14.7114ZM8.46122 11.2348L8.46408 11.237H8.45963L8.46122 11.2348ZM9.20627 10.2762C8.94833 10.5894 8.69998 10.9089 8.46122 11.2348C8.12754 10.9826 7.86148 10.6535 7.68633 10.2762H9.20627ZM1.86103 10.2762H0C0.118407 11.9104 0.623414 13.4944 1.47441 14.9007C2.32541 16.3071 3.49865 17.4966 4.89979 18.3735C5.12979 17.6052 5.39939 16.849 5.70753 16.1079C4.66263 15.4853 3.77386 14.6373 3.10774 13.6274C2.44162 12.6175 2.01542 11.4718 1.86103 10.2762ZM11.0301 16.8558C10.5273 17.856 10.1182 18.8997 9.80791 19.9736C10.059 19.9915 10.312 20.0004 10.5668 20.0004C11.0525 20.0004 11.5377 19.9674 12.0189 19.9017C12.7194 17.8145 13.8364 15.8873 15.3039 14.2339C16.7715 12.5806 18.5597 11.2346 20.563 10.2756H16.5732C14.2332 12.0141 12.3354 14.267 11.0301 16.8558ZM20.9091 11.8021C17.6811 13.4422 15.1585 16.1748 13.8022 19.5006V19.5011C15.5625 18.9394 17.1441 17.9338 18.3905 16.5836C19.6369 15.2333 20.505 13.5852 20.9091 11.8021ZM48.5743 14.7599C49.3023 14.9652 50.0536 15.0679 50.8283 15.0679C51.7243 15.0679 52.4849 14.9326 53.1103 14.6619C53.7356 14.3912 54.2023 14.0272 54.5103 13.5699C54.8276 13.1032 54.9863 12.5899 54.9863 12.0299C54.9863 11.3766 54.8136 10.8586 54.4683 10.4759C54.1323 10.0932 53.7263 9.81322 53.2503 9.63589C52.7743 9.45855 52.1629 9.28122 51.4163 9.10388C50.6976 8.94522 50.1609 8.78655 49.8063 8.62788C49.4609 8.45988 49.2883 8.20788 49.2883 7.87188C49.2883 7.53588 49.4376 7.26522 49.7363 7.05989C50.0443 6.85455 50.5156 6.75188 51.1503 6.75188C52.0556 6.75188 52.9609 7.00855 53.8663 7.52188L54.5663 5.79988C54.1183 5.51989 53.5956 5.30522 52.9983 5.15588C52.4009 5.00655 51.7896 4.93188 51.1643 4.93188C50.2683 4.93188 49.5076 5.06722 48.8823 5.33788C48.2663 5.60855 47.8043 5.97722 47.4963 6.44388C47.1883 6.90122 47.0343 7.41455 47.0343 7.98388C47.0343 8.63722 47.2023 9.15988 47.5383 9.55188C47.8836 9.94388 48.2943 10.2286 48.7703 10.4059C49.2463 10.5832 49.8576 10.7606 50.6043 10.9379C51.0896 11.0499 51.4723 11.1526 51.7523 11.2459C52.0416 11.3392 52.2749 11.4652 52.4523 11.6239C52.6389 11.7732 52.7323 11.9646 52.7323 12.1979C52.7323 12.5152 52.5783 12.7719 52.2703 12.9679C51.9623 13.1546 51.4863 13.2479 50.8423 13.2479C50.2636 13.2479 49.6849 13.1546 49.1063 12.9679C48.5276 12.7812 48.0283 12.5339 47.6083 12.2259L46.8383 13.9339C47.2769 14.2699 47.8556 14.5452 48.5743 14.7599ZM35.8971 5.09988V14.8999H34.0351L29.1491 8.94989V14.8999H26.9091V5.09988H28.7851L33.6571 11.0499V5.09988H35.8971ZM45.8037 13.0799V14.8999H38.2157V5.09988H45.6217V6.91988H40.4697V9.04788H45.0197V10.8119H40.4697V13.0799H45.8037ZM58.4293 6.94788H55.2933V5.09988H63.8333V6.94788H60.6973V14.8999H58.4293V6.94788ZM69.2461 4.99976H65.9545V5.82867H67.1295V8.99976H68.0628V5.82867H69.2461V4.99976ZM73.0711 6.71542L73.0795 8.99976H73.9545L73.9378 4.99976H73.1795L71.8295 7.40939L70.4461 4.99976H69.6795V8.99976H70.5545V6.77325L71.6045 8.5853H72.0211L73.0711 6.71542Z"
                            className="fill-current text-gray-50 md: group-hover:text-opacity-100 transition-colors duration-300 ease-linear"
                          />
                        </svg>
                      </a>
                    </div>
                  </li>
                </div>
              </ul>
            </div>

            <div className="order-1 md:order-2 mb-24 md:mb-0">
              <ul className="flex items-center flex-row flex-wrap space-x-4">
                <li className="text-sm">
                  <button
                    className="relative focus:outline-none font-normal text-gray-200 hover:text-gray-50 no-underline"
                    onKeyDown={citiesClickHandler}
                    onClick={citiesClickHandler}
                  >
                    <span className="flex items-center justify-between">
                      Cities
                      <i
                        className={`far fa-chevron-down ml-1 transition-all duration-300 ease-linear transform ${
                          cityDropdownOpen ? "rotate-180" : "rotate-0"
                        }`}
                      ></i>
                    </span>
                    <ul
                      className={`bg-gray-900 border border-primary-500 text-left absolute bottom-0 flex flex-col space-y-2 px-4 py-2 transform transition-all duration-300 ease-linear max-h-40 overflow-y-scroll ${
                        cityDropdownOpen
                          ? "opacity-100 -translate-y-10 visible"
                          : "opacity-0 -translate-y-4 invisible"
                      }`}
                    >
                      {navigation.cities.map((item) => (
                        <li className="whitespace-nowrap">
                          <AniLink
                            fade
                            to={item.href}
                            className="relative block text-sm text-gray-200 hover:text-primary-400 no-underline"
                          >
                            {item.name}
                          </AniLink>
                        </li>
                      ))}
                    </ul>
                  </button>
                </li>

                <li className="text-sm">
                  <button
                    className="relative focus:outline-none font-normal text-gray-200 hover:text-gray-50 no-underline"
                    onKeyDown={servicesClickHandler}
                    onClick={servicesClickHandler}
                  >
                    <span className="flex items-center justify-between">
                      Services
                      <i
                        className={`far fa-chevron-down ml-1 transition-all duration-300 ease-linear transform ${
                          serviceDropdownOpen ? "rotate-180" : "rotate-0"
                        }`}
                      ></i>
                    </span>
                    <ul
                      className={`bg-gray-900 border border-primary-500 text-left absolute bottom-0 flex flex-col space-y-2 px-4 py-2 transform transition-all duration-300 ease-linear ${
                        serviceDropdownOpen
                          ? "opacity-100 -translate-y-10 visible"
                          : "opacity-0 -translate-y-4 invisible"
                      }`}
                    >
                      {navigation.services.map((item) => (
                        <li className="whitespace-nowrap">
                          <AniLink
                            fade
                            to={item.href}
                            className="relative block text-sm text-gray-200 hover:text-primary-400 no-underline"
                          >
                            {item.name}
                          </AniLink>
                        </li>
                      ))}
                    </ul>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>

      <ModalContact />
    </>
  );
};

export default Footer;
